/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Kit 2 React componentss
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import constructionSite from "assets/images/screeding.png";
import buildingBlueprint from "assets/images/Image_showing_concrete_diamond_cutting.jpeg";
import modernInterior from "assets/images/site_cleaning.jpg";

const services = [
  {
    id: "service-1",
    title: "Concrete Screeding",
    description:
      "High-precision screeding solutions that ensure level, durable surfaces for industrial and commercial projects.",
    url: "/pages/landing-pages/our-services",
    imageUrl: constructionSite,
  },
  {
    id: "service-2",
    title: "Concrete Diamond Cutting & Drilling",
    description:
      "Clean, accurate cutting and core drilling for structural modifications, utility access, and complex architectural designs.",
    url: "/pages/landing-pages/our-services",
    imageUrl: buildingBlueprint,
  },
  {
    id: "service-3",
    title: "Project Handover Cleaning",
    description:
      "Detailed site cleaning services that leave your project presentation-ready and compliant with safety standards.",
    url: "/pages/landing-pages/our-services",
    imageUrl: modernInterior,
  },
];

function Services() {
  return (
    <MKBox component="section" py={6}>
      <Container>
        {/* Top layout: section title and description */}
        <Grid container item xs={12} md={8} sx={{ mx: "auto", textAlign: "left", mb: 6 }}>
          <MKTypography variant="h3" mb={1}>
            Our Core Services
          </MKTypography>
          <MKTypography variant="body1" color="text">
            Every service is managed by experienced professionals, ensuring precision, safety, and
            timely delivery on every project we undertake.
          </MKTypography>
        </Grid>

        {/* Cards row */}
        <Grid container spacing={4}>
          {services.map(({ id, title, description, url, imageUrl }) => (
            <Grid item xs={12} md={4} key={id}>
              <Card
                sx={({
                  boxShadows: { md },
                  borders: { borderRadius },
                  palette: { background },
                }) => ({
                  height: "100%",
                  position: "relative",
                  overflow: "hidden",
                  borderRadius: borderRadius.lg,
                  backgroundColor: background.paper,
                  cursor: "pointer",
                  transition: "transform 300ms ease, box-shadow 300ms ease",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: md,
                  },
                  "&:hover .service-overlay": {
                    opacity: 1,
                  },
                })}
              >
                <MKBox position="relative">
                  <MKBox
                    component="img"
                    src={imageUrl}
                    alt={title}
                    width="100%"
                    height="220px"
                    sx={{ objectFit: "cover" }}
                  />
                </MKBox>

                <MKBox p={3}>
                  <MKTypography variant="h5" mb={1}>
                    {title}
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    {description}
                  </MKTypography>
                </MKBox>

                {/* Hover overlay with link icon */}
                <MKBox
                  className="service-overlay"
                  sx={({ palette: { black }, functions: { rgba } }) => ({
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: rgba(black.main, 0.4),
                    opacity: 0,
                    transition: "opacity 300ms ease",
                  })}
                >
                  <MKBox
                    type="internal"
                    component="a"
                    href={url}
                    // target="_blank"
                    rel="noreferrer"
                    sx={({ palette: { white }, functions: { rgba } }) => ({
                      width: "3rem",
                      height: "3rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "50%",
                      backgroundColor: rgba(white.main, 0.1),
                      color: white.main,
                      border: `1px solid ${rgba(white.main, 0.6)}`,
                      textDecoration: "none",
                      transition: "background-color 200ms ease, transform 200ms ease",
                      "&:hover": {
                        backgroundColor: rgba(white.main, 0.25),
                        transform: "scale(1.05)",
                      },
                    })}
                  >
                    <Icon>arrow_forward</Icon>
                  </MKBox>
                </MKBox>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Bottom layout: supporting description */}
        {/* <Grid container item xs={12} md={8} sx={{ mx: "auto", textAlign: "center", mt: 6 }}>
          <MKTypography variant="body2" color="text">
            Every service is managed by experienced professionals, ensuring precision, safety, and
            timely delivery on every project we undertake.
          </MKTypography>
        </Grid> */}
      </Container>
    </MKBox>
  );
}

export default Services;
